import { makeActionCreator } from '../../../../utilities'
import { BodyAssessmentConstants } from './bodyAssessment.constants'

export const setSelectedExam = makeActionCreator(BodyAssessmentConstants.SET_SELECTED_EXAM, 'selectedExam')
export const setShowExamModal = makeActionCreator(BodyAssessmentConstants.SET_SHOW_EXAM_MODAL, 'showExamModal')
export const setBodySelectionMode = makeActionCreator(
  BodyAssessmentConstants.SET_BODY_SELECTION_MODE,
  'bodySelectionMode'
)
export const resetBodyAssessment = makeActionCreator(BodyAssessmentConstants.RESET_BODY_ASSESSMENT_STATE)
